/* eslint-disable import/prefer-default-export */
import { ScheduleStatus } from "enums/schedule.enum";
import { DerivedScheduleStatus } from "utils/derive-schedule-status";
import { humanize } from "utils/common";

export interface IScheduleStatusDisplay {
    label: string;
    backgroundColor: string;
    color: string;
}

export const DEFAULT_SCHEDULE_STATUS_KEY = "DEFAULT";

export const scheduleStatusDisplayMap: Record<string, IScheduleStatusDisplay> = {
    [ScheduleStatus.ACTIVE]: {
        label: "Active",
        backgroundColor: "#DBFCE7",
        color: "#4B6B3B",
    },
    [ScheduleStatus.SUSPENDED]: {
        label: "Suspended",
        backgroundColor: "#FFE2E2",
        color: "#BE4E55",
    },
    [ScheduleStatus.EXPIRED]: {
        label: "Expired",
        backgroundColor: "#F1F1F1",
        color: "#6B7280",
    },
    [DerivedScheduleStatus.FAILED]: {
        label: "Failed",
        backgroundColor: "#FEE2E2",
        color: "#B91C1C",
    },
    [DerivedScheduleStatus.STALLED]: {
        label: "Stalled",
        backgroundColor: "#FFEDD5",
        color: "#C2410C",
    },
    [DEFAULT_SCHEDULE_STATUS_KEY]: {
        label: "Unknown",
        backgroundColor: "#FFF9C4",
        color: "#B76E00",
    },
};

export const getScheduleStatusDisplay = (status: string): IScheduleStatusDisplay => {
    const match = scheduleStatusDisplayMap[status];
    if (match) {
        return match;
    }
    return {
        ...scheduleStatusDisplayMap[DEFAULT_SCHEDULE_STATUS_KEY],
        label: humanize(status),
    };
};
